<template>
    <div class="info-wrapper">
        <div class="info-title">{{info_title}}</div>
        <div v-if="type === '1'" class="info-lable">
            <span>{{time}}</span>
            <span>{{media}}</span>
            <span v-for="(item,index) in com_event_array" :key="index" class="tag">{{item.level_two_name}}</span>
        </div>
        <div v-else class="info-lable">
            <span>{{media}}</span>
            <span>{{time}}</span>
        </div>
        <div class="info-content" :class="{'zaobao':!isInfo}" v-html="content"></div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            info_title:"",
            news_id:"",
            media:"",
            type:"",//1:资讯  2：早报 3：复盘
            infoDetail:{},
            time:"",
            content:"",
            com_event_array:[],
            isInfo:true,
        };
    },
    created () {
        this.news_id = this.$route.query.news_id
        this.type = this.$route.query.type
    },
    mounted () {
        if(this.type === "1"){
            this.isInfo = true
            this.infoInit()
        }else{
            this.isInfo = false
            this.zaobaoInit()
        }
        const title = this.type === "1" ? "资讯正文" : (this.type === "2" ? "智眸早报" : "违约复盘")
        document.title = title
    },
    methods: {
        infoInit(){
            let params = {id:this.news_id}
            this.$http.post("/news/latestnewslist",params).then(res => {
                if(res.data && res.data.length){
                    this.infoDetail = res.data[0]
                    this.info_title = this.infoDetail.info_title
                    this.media = this.infoDetail.media
                    this.com_event_array = this.infoDetail.com_event_array
                    let current_day = this.getDate()
                    if(current_day === this.infoDetail.news_date){
                        this.time = this.infoDetail.info_publ_time.slice(0,5)
                    }else{
                        this.time = this.infoDetail.news_date
                    }
                    this.getContent()
                }
            })
        },
        zaobaoInit(){
            let params = {ids:this.news_id}
            this.$http.post("/news/reportdetail",params).then(res => {
                this.infoDetail = res.data
                this.info_title = this.infoDetail.title
                this.media = this.infoDetail.info_source
                this.time = this.infoDetail.publish_date
                if(this.type === "2"){
                    this.content = this.handleZaobaoContent(this.infoDetail.content)
                }else{
                    this.content = this.handleFupanContent(this.infoDetail.content)
                }
            })
        },
        handleZaobaoContent(content){
            content = content.replace(/style=\"font-size\:12\.0pt\"/g, 'class="violate-detail-content"')
            content = content.replace(/\<p /g, '<p class="paragraphFormat"')
            content = content.replace(/style=\"/g, '')
            content = content.replace(/style=\"/g, '')
            content = content.replace(/\<b/g, '<b style="color:#55B6FF"')
            return content
        },
        // 处理违约复盘
        handleFupanContent(content){
            let div = document.createElement("div")
            div.innerHTML = content
            let nodeList = div.getElementsByTagName("p")
            Array.from(nodeList).forEach(node => {
                let text = node.innerText
                let imgList = node.getElementsByTagName("img")
                let len = Array.from(imgList).length
                if(/[^\s]/.test(text)){
                    let childList = Array.from(node.children)
                    childList = this.recursiveNode(childList)
                    let innerHtml = ""
                    childList.map(item => {
                        innerHtml = innerHtml+item.innerHTML
                    })
                    node.innerHTML = `<p class="paragraphFormat">${innerHtml}</p>`
                }else if(len == 0){
                    div.removeChild(node)
                }
            })
            return div.innerHTML
        },
        recursiveNode(list){
            list.map(item => {
                item.style.fontSize = ""
                item.style.lineHeight = ""
                item.style.fontFamily = ""
                let childList = Array.from(item.children)
                this.recursiveNode(childList)
            })
            return list
        },
        getDate(){
            let date = new Date()
            let y = date.getFullYear()
            let m = date.getMonth() + 1
            let d = date.getDate()
            if(m < 10){
                m = "0"+m
            }
            return `${y}-${m}-${d}`
        },
        getSourceName(tname){
            let source_name = ""
            if (tname) {
                tname.match(/^DZ/) && (source_name = 'announce');
                tname.match(/^Bond/) && (source_name = 'bond');
                tname.match(/^NI/) && (source_name = 'opinion');
                tname.match(/^LC/) && (source_name = 'company');
                tname == 'LC_NotTextAnnouncement' && (source_name = 'company');
                tname == 'LC_ViolAnnouncement' && (source_name = 'sincerity');
                tname == 'LC_STIBNotTextAnnounce' && (source_name = 'stib');
                tname == 'PS_NewsPath' && (source_name = 'sentiment');
                tname == 'MF_NotTextAnnouncement=' && (source_name = 'fund');
                tname == 'NQ_Announcement' && (source_name = 'otc');
                tname == 'HK_NotText' && (source_name = 'hongkong');
                tname == 'CN_NewsPath' && (source_name = 'similarnew');
            }
            return source_name
        },
        getContent() {
            let url_id = this.infoDetail.url_id
            if (!url_id) {
                let arr =
                    this.infoDetail.path_array &&
                    this.infoDetail.path_array.filter((item) => {
                        return item.file_type == 5;
                    });
                let arr2 =
                    this.infoDetail.path_array &&
                    this.infoDetail.path_array.filter((item) => {
                        return item.file_type == 3;
                    });
                if (arr.length > 0) {
                    url_id = arr[0].url_id;
                } else {
                    if (arr2.length > 0) {
                        url_id = arr2[0].url_id;
                    } else {
                        this.content = "请点击查看原文";
                        return;
                    }
                }
                this.url_id = url_id
            }
            let source_name = this.getSourceName(this.infoDetail.tname)
            let params={source_name:source_name,url_id:this.url_id,id:this.url_id}
            this.$http.get("/file/content/attachment",params).then(res => {
                if (res.data && res.data[0].file_path){
                    let file_path = res.data[0].file_path
                    const protocol = window.location.protocol
                    let list = file_path.split(":")
                    file_path = `${protocol}${list[1]}`
                    this.downLink = file_path;
                    this.$http.get(this.downLink).then(res => {
                        this.content = res
                    })
                }
            })
        }
    }
};
</script>
<style lang="less" scoped>
.info-wrapper{
    box-sizing: border-box;
    width:100%;
    padding:.3rem;
    color:#303133;
    font-size: .36rem;
    text-align: left;
    .info-title{
        font-size: .4rem;
        line-height: .56rem;
        font-weight: bold;
    }
    .info-lable{
        width:100%;
        margin-top:.16rem;
        margin-bottom: .38rem;
        word-wrap: break-word;
        word-break: break-all;
        overflow: hidden;
        color:#909399;
        font-size: .28rem;
        line-height: .4rem;
        span{
            margin-right: .16rem;
        }
        .tag{
            color:#FF8E0D;
            font-size: .24rem;
        }
    }
    .info-content{
        /deep/.paragraphFormat{
            width:100%;
            text-indent: 0em;
            margin-bottom: 0.54rem;
            text-align: justify;
        }
        /deep/ img{
            width:100% !important;
            height:auto !important;
        }
        /deep/ .violate-detail-content{
            box-sizing: border-box;
            width:6.9rem;
            height:1.2rem;
            display: block;
            font-size:0.4rem !important;
            color: #002060;
            background:url("./images/zaobao-bg.svg") center center no-repeat;
            text-align: center;
            padding-top:.7rem;
        }
    }
    .zaobao{
        /deep/.paragraphFormat{
            margin-bottom: 0;
        }
    }
}
</style>
